var shake = 'fx_2d2fb1e5_uy1vpf0';

export { shake };
//# sourceMappingURL=animation.vanilla.mjs.map
